module.exports = __webpack_public_path__ + "static/anxious-desktop-45680e98985de51abf27fa051555764c.webp";